import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { UpsellModalComponent } from "src/app/components/upsell-modal/upsell-modal.component";
import { SharedModule } from "src/app/shared/shared.module";
import { BrandReviewsComponent } from "src/components/brand-reviews/brand-reviews";
import { UpsellButtonsComponent } from 'src/components/upsell-buttons/upsell-buttons';
import { UpsellFooterComponent } from "src/components/upsell-footer/upsell-footer";
import { UpsellGuaranteeComponent } from "src/components/upsell-guarantee/upsell-guarantee";
import { UpsellOfferSpinnerV2Component } from "src/components/upsell-offer-spinner-v2/upsell-offer-spinner-v2";
import { UpsellOfferSpinnerComponent } from 'src/components/upsell-offer-spinner/upsell-offer-spinner';
import { UpsellProductBoxFullComponent } from "src/components/upsell-product-box-full/upsell-product-box-full";
import { UpsellProductBoxComponent } from "src/components/upsell-product-box/upsell-product-box";
import { UpsellSectionComponent } from "src/components/upsell-section/upsell-section";
import { UpsellStepsComponent } from "src/components/upsell-steps/upsell-steps";
import { UpsellStickyBarV2 } from "src/components/upsell-sticky-bar-v2/upsell-sticky-bar-v2";
import { UpsellStickyBar } from "src/components/upsell-sticky-bar/upsell-sticky-bar";
import { UpsellWaitComponent } from "src/components/upsell-wait/upsell-wait";
import { UpsellWhyComponent } from "src/components/upsell-why/upsell-why";
import { SimpleVideoPlayerComponent } from "src/components/simple-video-player/simple-video-player";
import { UpsellCTAComponent } from "src/components/upsell-cta/upsell-cta";
import { VideoPlayerVidalyticsComponent } from 'src/components/video-player-vidalytics/video-player-vidalytics';
import { HartfeltHeaderComponent } from "src/components/hartfelt-header/hartfelt-header";
import { FaqsComponent } from "src/components/faqs/faqs";
import { VideoPlayerComponent } from "src/components/video-player/video-player";

@NgModule({
  declarations: [
    BrandReviewsComponent,
    SimpleVideoPlayerComponent,
    UpsellCTAComponent,
    UpsellButtonsComponent,
    UpsellFooterComponent,
    UpsellGuaranteeComponent,
    UpsellModalComponent,
    UpsellOfferSpinnerComponent,
    UpsellOfferSpinnerV2Component,
    UpsellProductBoxComponent,
    UpsellProductBoxFullComponent,
    UpsellSectionComponent,
    UpsellStepsComponent,
    UpsellStickyBar,
    UpsellStickyBarV2,
    UpsellWaitComponent,
    UpsellWhyComponent,
    VideoPlayerVidalyticsComponent,
    HartfeltHeaderComponent,
    FaqsComponent,
    VideoPlayerComponent
  ],
  exports: [
    BrandReviewsComponent,
    SimpleVideoPlayerComponent,
    UpsellCTAComponent,
    UpsellButtonsComponent,
    UpsellFooterComponent,
    UpsellGuaranteeComponent,
    UpsellModalComponent,
    UpsellOfferSpinnerComponent,
    UpsellOfferSpinnerV2Component,
    UpsellProductBoxComponent,
    UpsellProductBoxFullComponent,
    UpsellSectionComponent,
    UpsellStepsComponent,
    UpsellStickyBar,
    UpsellStickyBarV2,
    UpsellWaitComponent,
    UpsellWhyComponent,
    VideoPlayerVidalyticsComponent,
    HartfeltHeaderComponent,
    FaqsComponent,
    VideoPlayerComponent
  ],
  imports: [CommonModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UpsellModule { }